module.exports = __webpack_public_path__ + "static/img/event16.b8d1bbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event16.png
// module id = KhQD
// module chunks = 1